import React, { FC } from "react";
import { AppraisalSection } from "../AppraisalSection";
import { AppraisalAnnotationType } from "@shared/types/appraisalAnnotation";
import { useTranslation } from "@/react/lib/hooks";
import { AppraisalSectionsTranslations } from "@/react/lib/i18n/locales";
import { rootStore } from "@/react/lib/persistence/root_store";
import { CostList } from "@/react/domains/appraisal/Costs/CostList/CostList";
import { CostType } from "@shared/types/costs";
import { observer } from "mobx-react-lite";

const OtherCostsSection: FC = () => <OtherCostsSectionObserved />;

const OtherCostsSectionObserved: FC = observer(() => {
  const { t } = useTranslation();
  return (
    <AppraisalSection
      type={AppraisalAnnotationType.otherCosts}
      title={t(AppraisalSectionsTranslations.AppraisalSections_OtherCostsTitle)}
      testId="other-costs-section"
    >
      <CostList
        costType={CostType.OtherCost}
        calculationOptions={rootStore.calculationsStore.otherCostsCalculationOptions}
        costs={rootStore.costStore.otherCosts}
      />
    </AppraisalSection>
  );
});

export { OtherCostsSection };
